// apollo.ts
import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
  ServerError          // <- just for the type-guard
} from '@apollo/client/core';
import { setContext }  from '@apollo/client/link/context';
import { onError }     from '@apollo/client/link/error';
import router          from '@/router';

/* ------------------------------------------------------------------ */
/* 1. Plain HTTP link (always last in the chain)                       */
/* ------------------------------------------------------------------ */
const httpLink = createHttpLink({
  uri: `${process.env.VUE_APP_API_URL}/graphql`,  // Vite syntax; use process.env.* with Vue-CLI
});

/* ------------------------------------------------------------------ */
/* 2. Auth link – add headers here                                    */
/* ------------------------------------------------------------------ */
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
  return {
    headers: {
      ...headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
});

/* ------------------------------------------------------------------ */
/* 3. Error-handling link                                             */
/* ------------------------------------------------------------------ */
const errorLink = onError((error) => {
  // A) GraphQL 200 + errors[] branch


  console.log(error);
  // graphQLErrors?.forEach(err => {
  //   // if (err.message== 'Access Denied') {
  //   //   console.error('Access Denied');
  //   //    logoutAndRedirect();
  //   // }
  // });
  //
  // // B) Real HTTP-level 401/403
  // if (isServerError(networkError) && networkError.statusCode === 401) {
  //   logoutAndRedirect();
  // }
});

/* ------------------------------------------------------------------ */
/* 4. Helper functions                                                */
/* ------------------------------------------------------------------ */
function isServerError(err) {
  return typeof err === 'object' && err !== null && 'statusCode' in err;
}

function logoutAndRedirect() {
  localStorage.clear();
  apolloClient.clearStore().catch(() => {});
  router.replace( '/login' );
}

/* ------------------------------------------------------------------ */
/* 5. Bring the links together – NOTE the order                        */
/*    errorLink ➔ authLink ➔ httpLink                                 */
/* ------------------------------------------------------------------ */
const link = from([errorLink, authLink.concat(httpLink)]);

/* ------------------------------------------------------------------ */
/* 6. Finally create and export the client                            */
/* ------------------------------------------------------------------ */
export const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache({ addTypename: false }),
  defaultOptions: {
    watchQuery: { fetchPolicy: 'no-cache', errorPolicy: 'ignore' },
    query:      { fetchPolicy: 'no-cache', errorPolicy: 'all' },
  },
});

export default apolloClient;
